import { useContext, useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import TabContext from './subComponent/TabContext';

const TabPanel = ({ children, name, ...props }) => {
  const { selected } = useContext(TabContext);
  const [rendered, setRendered] = useState(false);

  const tabContent = useMemo(() => {
    if (rendered) {
      return children;
    }

    return null;
  }, [rendered, children]);

  useEffect(() => {
    if (name === selected) {
      setRendered(true);
    }
  }, [selected, name]);

  return (
    <Panel role='tabpanel' $display={selected === name} {...props}>
      {tabContent}
    </Panel>
  );
};

const Panel = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
  margin-top: 40px;
  margin-bottom: 24px;
  padding: 24px 32px;
`;

export default TabPanel;
